Service = App.loadClass 'core::Angular/Service'

class exports.MapsConversionService extends Service
    constructor: (@http, @rootScope, @window) ->
        @loadData @http.post('backend/grower/maps-conversion/get-input-files'), 'input_files', 'sort'
        @loadData @http.post('backend/grower/maps-conversion/get-matrix-rows'), 'matrix_rows'
        @statusQueueTableOffset = 0

        # This method acts as a hook and lets us update statuses in real time.
        @window.confirmation = (data) =>
            # Show the confirmation button if the vps_count is at least one
            @matrix_rows = true if data.vps_count > 0

            # Fetch input files again so status changes are reflected
            @updateInputFileStatuses()

    sort: () =>
        @input_files.sort(alphabeticalComparison.bind(null, ['uploaded_at', 'status']))


    alphabeticalComparison = (columns, a, b) ->
        # sort by prefered column first
        result = strnatcasecmp(a[columns[0]], b[columns[0]])

        # Sort by the second column if the preferred column was equal
        if result is 0
            result = strnatcasecmp(a[columns[1]], b[columns[1]])

        return result


    triggerResize: () =>
        @statusQueueTableOffset += 1


    loadData: (promise, key, callback = null) =>
        promise.then (response) =>
            if response?.data?.status?.type is 'success'
                @[key] = response.data.data
                if callback
                    @[callback]()
        return promise
